import { render, staticRenderFns } from "./loadingProgressBar.vue?vue&type=template&id=b389af8e&scoped=true&"
import script from "./loadingProgressBar.vue?vue&type=script&lang=ts&"
export * from "./loadingProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./loadingProgressBar.vue?vue&type=style&index=0&id=b389af8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b389af8e",
  null
  
)

export default component.exports